import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

export const TrainIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
  direction,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''} ${direction || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="train-icon"
      viewBox="0 0 24 24"
    >
      <g fill={fill} clipPath="url(#clip0_1514_176078)">
        <path d="M16.61 18.14h-1.69l.72 1.18H8.89l.73-1.18H7.93L6 21.28h1.69l.72-1.18h7.71l.73 1.18h1.68l-1.92-3.14zM18.53 15.498v-8.44c0-2.88-3.12-3.71-5-4a8.41 8.41 0 00-2.6 0c-1.84.25-5 1.08-5 4v8.44s-.15 2.12 1.56 2.12h9.4c1.79 0 1.64-2.12 1.64-2.12zm-10.44.23a1 1 0 110-2 1 1 0 010 2zm3.66-5.45a.4.4 0 01-.4.4H7.62a.6.6 0 01-.57-.61v-2.43a.6.6 0 01.58-.62h3.72a.4.4 0 01.4.4v2.86zm4.7 5.39a1 1 0 110-2 1 1 0 010 2zm1-5.61a.602.602 0 01-.58.62h-3.68a.4.4 0 01-.4-.4v-2.85a.41.41 0 01.41-.41h3.72a.6.6 0 01.57.62l-.04 2.42z" />
      </g>
      <defs>
        <clipPath id="clip0_1514_176078">
          <path
            fill={fill || '#7E8A96'}
            d="M0 0H12.53V18.28H0z"
            transform="translate(6 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrainIcon;
